import { ReactComponent as CardFillIconSvg } from '../../icons/card.fill.svg';

export default function CardFillIcon({ linearGradient = false, ...props }) {
  return (
    <CardFillIconSvg
      width={'16px'}
      height={'16px'}
      fill={linearGradient ? 'url(#customGradient)' : 'white'}
      {...props}
    />
  );
}
